function CenterCenterVerticalContainer(props) {

	return (
		<div className="d-flex flex-fill flex-column justify-content-center align-items-center p-1">
			{props.children}
		</div>
	);
}

export default CenterCenterVerticalContainer;